import httpClient from "./httpClient";

const prefix = "/authorized-permissions";

export interface AuthorizedPermission {
  id?: number;
  title: string;
  maxDays: number;
  requiresEvidence: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export async function getAllAuthorizedPermissions() {
  try {
    const response = await httpClient.get(prefix);
    return response.data;
  } catch (error) {
    console.error("Error fetching authorized permissions:", error);
    throw error;
  }
}

export async function createAuthorizedPermission(data: Omit<AuthorizedPermission, "id" | "createdAt" | "updatedAt">) {
  try {
    const response = await httpClient.post(prefix, data);
    return response.data;
  } catch (error) {
    console.error("Error creating authorized permission:", error);
    throw error;
  }
}

export async function updateAuthorizedPermission(
  id: number,
  data: Omit<AuthorizedPermission, "id" | "createdAt" | "updatedAt">
) {
  try {
    const response = await httpClient.patch(`${prefix}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating authorized permission:", error);
    throw error;
  }
}

export async function deleteAuthorizedPermission(id: number) {
  try {
    const response = await httpClient.delete(`${prefix}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting authorized permission:", error);
    throw error;
  }
}

